import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';

function CommonEnquiryFields({ onDataChange, initialData }) {
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierSearch, setSupplierSearch] = useState(" ");
    const [supplier, setSupplier] = useState(initialData?.supplier || null);
    const [isSupplierOpen, setIsSupplierOpen] = useState(false);

    const [supplierDetails, setSupplierDetails] = useState({
        contactperson: initialData?.supplierDetails?.contactperson || '',
        contactno: initialData?.supplierDetails?.contactno || '',
        email: initialData?.supplierDetails?.email || '',
    });

    const [supplierAddresses, setSupplierAddresses] = useState([]);
    const [supplierMultipleAddress, setSupplierMultipleAddress] = useState(initialData?.supplierMultipleAddress || null);

    useEffect(() => {
        if (initialData?.supplier?.value) {
            getSupplierAddresses(initialData.supplier.value);
        }
    }, [initialData]);

    const handleSearchChangeSupplier = debounce((inputValue) => {
        setSupplierSearch(inputValue || " ");
    }, 300);

    useEffect(() => {
        getSupplierData();
    }, [supplierSearch]);

    const getSupplierData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}supplier/page/0/10/asc/id/${encodeURIComponent(supplierSearch)}`,
                { headers: authHeader() }
            );

            const suppliers = response.data.Index || response.data.data || [];

            setSupplierOptions(
                suppliers.map((s) => ({
                    value: s.id,
                    label: s.companyname,
                    contactperson: s.contactperson,
                    contactno: s.contactno,
                    email: s.email,
                }))
            );
        } catch (error) {
            console.error("Error fetching supplier data", error);
        }
    };

    const getSupplierAddresses = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}supplierMultipleAddress/getAddress/${id}`, {
                headers: authHeader(),
            });
            setSupplierAddresses(response.data.map(addr => ({
                value: addr.id,
                label: addr.supplieraddress,
            })));
        } catch (error) {
            console.error("Error fetching supplier addresses", error);
        }
    };

    const handleSupplierChange = (selected) => {
        setSupplier(selected);
        if (selected) {
            setSupplierDetails({
                contactperson: selected.contactperson,
                contactno: selected.contactno,
                email: selected.email,
            });
            getSupplierAddresses(selected.value);
            setIsSupplierOpen(true); 
        } else {
            setSupplierDetails({
                contactperson: '',
                contactno: '',
                email: '',
            });
        }
        setSupplierMultipleAddress(null);
    };

    const handleDataUpdate = () => {
        if (onDataChange) {
            onDataChange({
                supplier,
                supplierDetails,
                supplierMultipleAddress,
            });
        }
    };

    useEffect(() => {
        handleDataUpdate();
    }, [ supplier, supplierDetails, supplierMultipleAddress]);

    const toggleSupplierSection = () => {
        setIsSupplierOpen(!isSupplierOpen);
    };
  
    return (
        <>
            <br />
            <div className="supplier-accordion-container">
                <div
                    className={`supplier-accordion-header ${isSupplierOpen ? 'supplier-accordion-open' : ''}`}
                    onClick={toggleSupplierSection}
                >
                    <h7>Supplier Information</h7>
                    <span className="supplier-accordion-icon">
                        {isSupplierOpen ? '−' : '+'}
                    </span>
                </div>

                <div className={`supplier-accordion-content ${isSupplierOpen ? 'supplier-accordion-content-show' : ''}`}>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Supplier</Form.Label>
                                <Select
                                    options={supplierOptions}
                                    onChange={handleSupplierChange}
                                    onInputChange={handleSearchChangeSupplier}
                                    value={supplier}
                                    placeholder="Select supplier"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Contact Person</Form.Label>
                                <Form.Control
                                    value={supplierDetails.contactperson}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                    value={supplierDetails.contactno}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    value={supplierDetails.email}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Supplier Address</Form.Label>
                                <Select
                                    options={supplierAddresses}
                                    value={supplierMultipleAddress}
                                    onChange={(val) => setSupplierMultipleAddress(val)}
                                    isClearable
                                    placeholder="Select address"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default CommonEnquiryFields;
  

